import clsx from 'clsx';
import React, { Fragment } from 'react';
import { createStyles, lighten, makeStyles } from '@material-ui/core';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
var useToolbarStyles = makeStyles(function (theme) {
    return createStyles({
        root: {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(1),
        },
        highlight: theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
        title: {
            flex: '1 1 100%',
        },
        filtersToolBar: {
            backgroundColor: '#efefef',
            border: '1px dotted grey',
        },
    });
});
var ExactaEmbeddedTableToolbar = function (_a) {
    var title = _a.title, actions = _a.actions;
    var t = useTranslation().t;
    var classes = useToolbarStyles({});
    return (React.createElement(Fragment, null,
        React.createElement(Toolbar, { className: clsx(classes.root) },
            React.createElement(Typography, { className: classes.title, variant: "h6", id: "tableTitle", component: "div" }, t(title)),
            React.createElement(Actions, { actions: actions }))));
};
var Actions = function (_a) {
    var actions = _a.actions;
    return (React.createElement(Fragment, null, actions.map(function (Action, index) {
        return React.createElement(Action, { key: "table-action-" + index });
    })));
};
export default ExactaEmbeddedTableToolbar;
//# sourceMappingURL=ExactaEmbeddedTableToolbar.js.map